import baseTheme from '../baseTheme';
var MuiMenuItem = {
    root: {
        // extra specificity to override ListItem rules
        '&': {
            border: 'none',
            borderRadius: 0,
            '&.Mui-selected': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
                border: 'none',
            },
            fontSize: baseTheme.typography.pxToRem(14),
            '&.Mui-selected::after': {
                content: 'none',
            },
            // Lots of extra specificity needed...
            '&&&&': {
                border: 'none',
                // Can't use `$focusVisible` because technically MenuItem doesn't have focused... but ListItem does
                '&:hover, &.Mui-focusVisible': {
                    backgroundColor: baseTheme.palette.primary.light,
                },
                '& + &': {
                    marginTop: 0,
                    borderTop: "1px solid " + baseTheme.palette.grey[300],
                },
            },
        },
    },
    gutters: {
        minHeight: 24,
    },
};
export default MuiMenuItem;
//# sourceMappingURL=MuiMenuItem.js.map